module.exports = __webpack_public_path__ + "img/renzheng_xsz.2e4aad3b.png";